import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';

export type CustomSnackBarType = 'success' | 'info' | 'warning' | 'error' | 'default';

export interface CustomSnackBarData {
    message: string;
    snackBar: MatSnackBar;
    type: CustomSnackBarType;
}

@Component({
    selector: 'app-custom-snackbar',
    templateUrl: './custom-snackbar.component.html',
    styleUrls: ['./custom-snackbar.component.scss'],
})
export class CustomSnackbarComponent implements OnInit {
    message: string | null = null;
    type: CustomSnackBarType | null = null;
    icon: string = 'info';
    typeText: string | null = null;

    constructor(@Inject(MAT_SNACK_BAR_DATA) private snackBarData: CustomSnackBarData) {}

    ngOnInit(): void {
        this.message = this.snackBarData.message;
        this.type = this.snackBarData.type;

        this.setIcon(this.type);
    }

    dismiss(): void {
        this.snackBarData.snackBar.dismiss();
    }

    private setIcon(type: CustomSnackBarType): void {
        switch (type) {
            case 'success':
                this.icon = 'done';
                break;
            case 'info':
                this.icon = 'info';
                this.typeText = 'Информация';
                break;
            case 'warning':
                this.icon = 'warning';
                this.typeText = 'Предупреждение';
                break;
            case 'error':
                this.icon = 'error';
                this.typeText = 'Ошибка';
                break;
            case 'default':
                this.icon = 'textsms';
                break;
        }
    }
}

